<mat-drawer-container id="managers_add_edit_main_container" autosize>
  <mat-card id="managers_add_edit_mat_card">
    <mat-card-content class="form-mat-card-content">
      <div id="managers_add_edit_header" class="page-header">
        <span id="managers_add_edit_header_text" class="page-header-text">
          {{ type() | titlecase }} Manager
        </span>
        <span class="spacer"></span>
        <button
          mat-button
          id="managers_add_edit_cancel_1"
          class="add-edit-button white-button margin-right-15"
          routerLink="/managers">
          Cancel
        </button>
        <button
          mat-button
          id="managers_add_edit_save"
          class="add-edit-button save-button"
          [ngClass]="{ 'invalid-button': !managerForm.valid }"
          (click)="onSubmit()">
          Save
        </button>
      </div>
      <hr class="custom-hr" />
      @if (!loading()) {
        <form
          id="manager_form"
          class="custom-form grid-form"
          [formGroup]="managerForm"
          (ngSubmit)="onSubmit()">
          <div id="managers_add_edit_first_name" class="position-relative">
            <div id="form_input_title_first_name" class="form-input-title">First Name:</div>
            <mat-form-field
              id="manager_first_name_field"
              class="form-field-custom form-field-input">
              <input
                matInput
                id="manager_first_name_input"
                class="shared-input-field"
                maxlength="50"
                formControlName="firstName"
                autocomplete="off" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                managerForm.controls['firstName'].touched &&
                !managerForm.controls['firstName'].valid
              ) {
                <mat-error id="manager_last_name_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('firstName') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="managers_add_edit_last_name" class="position-relative">
            <div id="form_input_title_last_name" class="form-input-title">Last Name:</div>
            <mat-form-field id="manager_last_name_field" class="form-field-custom form-field-input">
              <input
                matInput
                id="manager_last_name_input"
                class="shared-input-field"
                maxlength="50"
                formControlName="lastName"
                autocomplete="off" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                managerForm.controls['lastName'].touched && !managerForm.controls['lastName'].valid
              ) {
                <mat-error id="manager_last_name_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('lastName') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="managers_add_edit_email" class="position-relative">
            <div id="form_input_title_email" class="form-input-title">Email:</div>
            <mat-form-field id="manager_email_field" class="form-field-custom form-field-input">
              <input
                matInput
                id="manager_email_input"
                class="shared-input-field"
                maxlength="50"
                formControlName="email"
                autocomplete="off" />
            </mat-form-field>
            <span class="error-space-holder">
              @if (
                (managerForm.controls['email'].touched && !managerForm.controls['email'].valid) ||
                uniqueCustomerEmail() === false
              ) {
                <mat-error id="manager_lemail_error" class="error input-error">
                  <i class="fas fa-exclamation-triangle error-icon"></i
                  >{{ getErrorMessage('email') }}
                </mat-error>
              }
            </span>
          </div>
          <div id="managers_add_edit_enabled" class="position-relative">
            <div id="form_input_title_enabled" class="form-input-title">Enabled:</div>
            <mat-form-field id="manager_enabled_field" class="form-field-custom add-edit-dropdown">
              <mat-select
                id="enabled_select"
                placeholder="Enabled Status"
                formControlName="enabled">
                @for (status of statusList; track status) {
                  <mat-option id="enabled_dropdown_{{ status.name }}" [value]="status.value">
                    {{ status.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- TODO - When BI is a selectable option for Account Managers
          <div id="managers_add_edit_business" class="position-relative">
            <div id="form_input_title_business" class="form-input-title">Business Intelligence:</div>
            <mat-form-field id="manager_business_field" class="form-field-custom add-edit-dropdown">
              <mat-select id="business_select" placeholder="Business Intelligence Status"
                formControlName="businessIntelligenceAccess">
                <mat-option id="business_dropdown_{{status.name}}"
                  *ngFor="let status of statusList" [value]="status.value">
                  {{ status.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->
          <div class="row span-all-cols">
            <div class="col-5 custom-col-5">
              <div id="delected_title" class="form-input-title">
                Deselected Customers:
                <span matTooltip="You can only add enabled customers!" [matTooltipShowDelay]="500">
                  <i class="fal fa-info-circle"></i>
                </span>
              </div>
              <div class="customer-lists">
                <input
                  id="deselected_input"
                  class="custom-input"
                  type="text"
                  name="de_cus"
                  (input)="searchDeselected($event.target.value)" />
                <div id="select_element_list" class="scrollable">
                  @for (cus of deselectedList() | keyvalue: asIsOrder; track cus) {
                    <div
                      id="customer_{{ cus.key }}_to_be_select"
                      class="individual-customers extra-padding"
                      (click)="
                        checkbox.toggle(); deselectCheck(checkbox.checked, cus.key, cus.value)
                      ">
                      {{ cus.key }}
                      <mat-checkbox
                        #checkbox
                        id="customer_{{ cus.key }}_checkbox"
                        class="cus-check float-checkbox-right">
                      </mat-checkbox>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="col-2 custom-col-2 push-buttons-holder">
              <button
                mat-button
                id="select_customer_button"
                class="shared-push push-right-button"
                type="button"
                (click)="selectCustomer()">
                <i class="fas fa-chevron-double-right icon"></i>
              </button>
              <button
                mat-button
                id="deselect_customer_button"
                class="shared-push push-left-button"
                type="button"
                (click)="deselectCustomer()">
                <i class="fas fa-chevron-double-left"></i>
              </button>
            </div>
            <div class="col-5 custom-col-5">
              <div id="deselected_title" class="form-input-title">Selected Customers:</div>
              <div class="customer-lists">
                <input
                  id="selected_input"
                  class="custom-input"
                  type="text"
                  name="se_cus"
                  (input)="searchSelected($event.target.value)" />
                <div class="scrollable">
                  @for (cus of selectedList() | keyvalue: asIsOrder; track cus) {
                    <div
                      id="customer_{{ cus.key }}_to_be_deselect"
                      class="individual-customers extra-padding"
                      (click)="
                        otherChecked.toggle(); selectCheck(otherChecked.checked, cus.key, cus.value)
                      ">
                      {{ cus.key }}
                      <mat-checkbox
                        #otherChecked
                        class="cus-check float-checkbox-right"></mat-checkbox>
                    </div>
                  }
                </div>
              </div>
              <span class="error-space-holder">
                @if (
                  managerForm.get('customers')?.hasError('tooMany') ||
                  (managerForm.get('customers')?.hasError('required') &&
                    managerForm.get('customers')?.touched)
                ) {
                  <mat-error id="acetech_customer_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('customers') }}
                  </mat-error>
                }
              </span>
            </div>
          </div>
          <div id="managers_add_edit_cancel_2" class="buttons-row span-all-cols">
            <button
              mat-button
              id="managers_add_edit_cancel_button"
              class="add-edit-button white-button"
              routerLink="/managers">
              Cancel
            </button>
            <button
              mat-button
              type="submit"
              id="managers_add_edit_save_2"
              class="add-edit-button save-button"
              [ngClass]="{
                'invalid-button': !uniqueCustomerEmail() || !managerForm.valid,
              }">
              Save
            </button>
          </div>
        </form>
      }
      @if (loading()) {
        <app-loading-spinner />
      }
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
